import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/utilities.css';
import TourFab from './components/TourFab';

import Header from './components/Header';
import Sidebar from './components/Sidebar';

import LoginForm from './LoginForm';
import ResetHaslaRequest from './ResetHaslaRequest';
import ResetHaslaUstaw from './ResetHaslaUstaw';
import RegisterForm from './RegisterForm';
import TeacherRegisterForm from './TeacherRegisterForm';
import StudentRegister from './views/student/StudentRegister';
import LogowanieSEB from './LogowanieSEB';
import Polityka from './PolitykaPrywatnosci';

import AdminRouter from './routes/AdminRouter';
import StudentRouter from './routes/StudentRouter';
import TeacherRouter from './routes/TeacherRouter';

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Responsive: <1000px => mobile, sidebar domyślnie schowany
    const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 1000px)').matches);
    const [collapsed, setCollapsed] = useState(() => window.matchMedia('(max-width: 1000px)').matches);

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 1000px)');
        const onChange = (e) => {
            setIsMobile(e.matches);
            setCollapsed(e.matches ? true : false); // desktop => pokaż sidebar, mobile => schowaj
        };
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }

        fetch('/api/uzytkownicy/auth/me', {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => (res.ok ? res.json() : Promise.reject()))
            .then(data => setUser(data))
            .catch(() => {
                localStorage.removeItem('token');
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <p>⏳ Ładowanie...</p>;

    const ProtectedRoute = ({ role, children }) => {
        if (!user) return <Navigate to="/" />;
        if (role && user.rola !== role) return <Navigate to="/" />;
        return children;
    };

    // Szerokości sidebaru (spójne z Header/Sidebar)
    const SID_COLLAPSED = 64; // px
    const SID_EXPANDED = 220; // px

    return (
        <Router>
            {user && (
                <Header
                    user={user}
                    collapsed={collapsed}
                    isMobile={isMobile}
                    setCollapsed={setCollapsed} // umożliwia otwieranie z hamburgera
                />
            )}
            {user && (
                <Sidebar
                    user={user}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    isMobile={isMobile}
                />
            )}

            <div
                style={{
                    marginLeft: user
                        ? (collapsed ? `60px` : `245px`)
                        : '0',
                    transition: 'margin-left 0.2s ease'
                }}
            >
                <Routes>
                    {/* Publiczne ścieżki */}
                    {!user && (
                        <>
                            <Route path="/" element={<LoginForm onLoginSuccess={setUser} />} />
                            <Route path="/reset-hasla" element={<ResetHaslaRequest />} />
                            <Route path="/reset-hasla/:token" element={<ResetHaslaUstaw />} />
                            <Route path="/rejestracja_2" element={<RegisterForm />} />
                            <Route path="/rejestracja-prowadzacy" element={<TeacherRegisterForm />} />
                            <Route path="/rejestracja" element={<StudentRegister />} />
                            <Route path="/polityka-prywatnosci" element={<Polityka />} />
                            <Route path="/logowanie-seb" element={<LogowanieSEB onLoginSuccess={setUser} />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </>
                    )}

                    {/* Routing z ochroną per rola */}
                    {user?.rola === 'admin' && (
                        <Route
                            path="/admin/*"
                            element={
                                <ProtectedRoute role="admin">
                                    <AdminRouter user={user} />
                                </ProtectedRoute>
                            }
                        />
                    )}

                    {user?.rola === 'student' && (
                        <Route
                            path="/student/*"
                            element={
                                <ProtectedRoute role="student">
                                    <StudentRouter user={user} />
                                </ProtectedRoute>
                            }
                        />
                    )}

                    {user?.rola === 'prowadzacy' && (
                        <Route
                            path="/prowadzacy/*"
                            element={
                                <ProtectedRoute role="prowadzacy">
                                    <TeacherRouter user={user} />
                                </ProtectedRoute>
                            }
                        />
                    )}

                    {/* Domyślnie przekieruj */}
                    {user && <Route path="*" element={<Navigate to={`/${user.rola}`} />} />}
                </Routes>
            </div>

            <TourFab />
        </Router>
    );
}

export default App;
